

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import moment from 'moment-timezone';

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form14";
const form14State = namespace("Form14");

import { form14DataInfoType, form14PartiesInfoType } from '@/types/Information/Form14';
import { partiesDataJsonDataType } from '@/types/Information/json';

import AddPartyForm from './AddPartyForm.vue';
import AddPartyModal from './AddPartyModal.vue';

@Component({
    components:{
        AddPartyForm,
        AddPartyModal        
    }
})
export default class Form14StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;   

    @informationState.State
    public fileNumber: string;

    @form14State.State
    public form14Info: form14DataInfoType;

    @form14State.Action
    public UpdateForm14Info!: (newForm14Info: form14DataInfoType) => void  
    
    @form14State.State
    public currentConsentOrderRemoveInactiveId: string;

    @form14State.Action
    public UpdateCurrentConsentOrderRemoveInactiveId!: (newCurrentConsentOrderRemoveInactiveId: string) => void
    
    dataReady = false;
    updated=0;     
  
    addRespondentFormColor = 'court';
    AddNewRespondentForm = false;

    addAppellantFormColor = 'court';
    AddNewAppellantForm = false;

    partyNames: form14PartiesInfoType[] = [];
    

    partyToEdit = {} as form14PartiesInfoType;
    showPartyWindow = false
    isCreate = true
    partyType = ''   
    seekingRemovedOptions = [
        'appeal',
        'application for leave to appeal',
        'cross appeal',
        'application for leave to cross appeal'
    ]

    partyFields = [
        { key:'organization', label:'Party Type', thClass: 'text-white bg-court', thStyle: '', sortable:false }, 
        { key:'name', label:'Party Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'counselName', label:'Counsel Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'edit', label:'', thClass: 'text-white bg-court', sortable:false }        
    ]   

    state = { 
        appellantsInfo: null,
        respondentsInfo: null,
        seekingRemoved: null,
        signingParties: null       
    }    

    mounted() {
        this.dataReady = false;        
        this.extractInfo();              
    }
    
    public extractInfo(){       

        if(this.currentConsentOrderRemoveInactiveId){
            this.getForm14Data();
           
        } else { 

            const form14Data = this.form14Info;            
            form14Data.version = this.$store.state.Application.version;
            form14Data.seekingRemoved = [];
            form14Data.signingParties = []; 
            form14Data.appellants = this.partiesJson.appellants
            form14Data.respondents = this.partiesJson.respondents
            form14Data.formSevenNumber = this.fileNumber; 
            form14Data.orderDate = moment().format("YYYY-MM-DD")
            
            this.UpdateForm14Info(form14Data);           
            this.revaluateForm14Data();            
            this.saveForm(true);
        }          
    }

    public revaluateForm14Data(){

        const form14Data = this.form14Info;

        for (const respondent of form14Data.respondents){
            if (respondent.firstName && respondent.lastName){                    
                respondent.isOrganization = false;
            } else if (respondent.organization){
                respondent.isOrganization = true;
            }
            if(respondent.solicitor?.counselFirstName && respondent.solicitor?.counselLastName)
                respondent.counselName = respondent.solicitor.counselFirstName+' '+respondent.solicitor.counselLastName                          
            respondent.responding = true;
        }

        for (const applicant of form14Data.appellants){
            if (applicant.firstName && applicant.lastName){
                applicant.isOrganization = false;
            } else if (applicant.organization){
                applicant.isOrganization = true;
            }
            if(applicant.solicitor?.counselFirstName && applicant.solicitor?.counselLastName)
                applicant.counselName = applicant.solicitor.counselFirstName+' '+applicant.solicitor.counselLastName             
            applicant.responding = false;
        }

        const appellants = form14Data.appellants.map(resp=>resp.name)
        const respondents = form14Data.respondents.map(resp=>resp.name)
        form14Data.appellantNames = appellants.join(', ');
        form14Data.respondentNames = respondents.join(', ');

        this.partyNames = [...form14Data.appellants, ...form14Data.respondents]
        this.UpdateForm14Info(form14Data);
    }

    public getForm14Data() {        
       
        this.$http.get('/form14/forms/'+this.currentConsentOrderRemoveInactiveId)
        .then((response) => {
            if(response?.data?.data){
                const form14Data = response.data.data
                this.UpdateForm14Info(form14Data);
                this.revaluateForm14Data();               
                this.clearStates();                
            }                
        },(err) => {
            console.log(err)        
        });      
    }

    public clearStates(){
        this.state = {
            appellantsInfo: null,
            respondentsInfo: null,
            seekingRemoved: null,
            signingParties: null            
        }
        this.dataReady = true; 
    }

    public recheckStates(dontFindInvalidFields?){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates(dontFindInvalidFields)
                return 
            }
        }
    }

    public checkStates(dontFindInvalidFields?){  
        
        this.state.appellantsInfo = this.form14Info.appellants?.length>0? null :false;
        this.state.respondentsInfo = this.form14Info.respondents?.length>0? null :false;            
        this.state.seekingRemoved = this.form14Info.seekingRemoved?.length>0? null :false;
        this.state.signingParties = this.form14Info.signingParties?.length>0? null :false;
        
        if(dontFindInvalidFields == true) return true
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    } 

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form14/forms';

        if (this.currentConsentOrderRemoveInactiveId){
            method = 'put';
            url = '/form14/forms/'+this.currentConsentOrderRemoveInactiveId;
            const form14Data = this.form14Info;            
            this.UpdateForm14Info(form14Data);

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form14Info,
                    type:'Form14',
                    description:'Consent order to remove an appeal from the inactive list'
                }
            }
            this.saveInfo(options, draft);

        } else {
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form14Info,
                    type:'Form14',
                    description:'Consent order to remove an appeal from the inactive list'
                }
            }
            this.saveInfo(options, draft);
        }
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentConsentOrderRemoveInactiveId(response.data.file_id); 
                    }

                    this.clearStates();                                     
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;                
            })
    }

    public addNewRespondent(){
        this.state.respondentsInfo = null
        this.partyToEdit = {} as form14PartiesInfoType
        this.partyType = 'Respondent'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editRespondent(data) {
        this.partyToEdit = data.item
        this.partyType = 'Respondent';
        this.isCreate = false;
        this.showPartyWindow = true;
    }

    public removeRespondent(data){ 
        const form14Data = this.form14Info;       
        form14Data.respondents.splice(data.index,1);
        form14Data.respondentNames = form14Data.respondents.map(resp=>resp.name).join(', ');
        this.partyNames = [...form14Data.appellants, ...form14Data.respondents]
        this.somePartiesChanged()
        this.UpdateForm14Info(form14Data);
        this.updated ++;        
    }

    public addNewAppellant(){
        this.state.appellantsInfo = null
        this.partyToEdit = {} as form14PartiesInfoType
        this.partyType = 'Appellant'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editAppellant(data) {
        this.partyToEdit = data.item
        this.partyType = 'Appellant';
        this.isCreate = false;
        this.showPartyWindow = true;        
    }

    public removeAppellant(data){   
        const form14Data = this.form14Info;       
        form14Data.appellants.splice(data.index,1); 
        form14Data.appellantNames = form14Data.appellants.map(resp=>resp.name).join(', ');
        this.partyNames = [...form14Data.appellants, ...form14Data.respondents]        
        this.somePartiesChanged()
        this.UpdateForm14Info(form14Data);
        this.updated ++;        
    }

    public partyChanged(partyCreated){
        if(partyCreated){
            const form14Info = this.form14Info
            const party = JSON.parse(JSON.stringify(this.partyToEdit))
            if(this.partyType == 'Appellant'){
                form14Info.appellants.push(party);
            }
            else if(this.partyType =='Respondent'){
                form14Info.respondents.push(party);
            }
            this.UpdateForm14Info(form14Info)
        }
        this.revaluateForm14Data();
        this.showPartyWindow = false;
        this.somePartiesChanged() 
        this.updated++;
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form14"}) 
    }

    public somePartiesChanged(){   
        this.form14Info.signingParties = [];    
        this.updated++;
    }    

    public getCounselParty(party){

        if(party.counselName){
            const counsel: form14PartiesInfoType = JSON.parse(JSON.stringify(party))
            counsel.isCounsel = true
            counsel.name = counsel.counselName+', counsel for '+counsel.name
            return counsel
        }        
        return party
    }

}
